import { createCpmsBoRoleSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-role.slice';

import { cpmsBoRoleApi } from './cpms-bo-role.service';

export const cpmsBoRoleSlice = createCpmsBoRoleSlice({ cpmsBoRoleApi });
